import Vue from '../main/vue';
import store from '../main/vue-store';
import router from '../main/vue-routes';
import ProductConfiguratorViewer from './product-configurator-viewer';
import VueMq from 'vue-mq';

const loadProductConfigurator = () => {
  if (document.querySelector('.product-configurator')) {
    Vue.use(VueMq, {
      breakpoints: {
        md: 1200,
        lg: Infinity
      }
    });

    new Vue({
      el: '.product-configurator',
      comments: true,
      components: {
        ProductConfiguratorViewer
      },
      store,
      router
    });
  }
};

export default loadProductConfigurator;
